import { boundingExtent, buffer } from 'ol/extent';

export function featureSortFunction (a, b) { // y-sort
  return photoFeatureLocation(a)[1] - photoFeatureLocation(b)[1];
}

export function photoFeatureLocation (feature) {
  return feature.getGeometry().getFirstCoordinate();
}

export function extentAt (point, size) {
  return buffer(boundingExtent([ point ]), size / 2);
}
